import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Injector,
  ModuleWithProviders,
  NgModule,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VisibilityAreaService } from '@shared/services/visibility-area.service';

import { GlobalSpinnerComponent } from './components/global-spinner/global-spinner.component';

import {
  BrandingService,
  DataApiService,
  DimensionService,
  FiltersService,
  FormUtilsService,
  KpiService,
  OrUserSettingsService,
  SubjectAreaService,
  ToastrService,
} from './services';

import { GroupMenuComponent } from '@observation/components/insights/my-insights/group-menu/group-menu.component';
import { SettingsMenuComponent } from '@observation/shared/components/settings-menu/settings-menu.component';
import { LoadingPipe } from '@pipes/loading.pipe';
import { NewLinePipe } from '@pipes/new-line.pipe';
import { RemoveHyphenPipe } from '@pipes/remove-hyphen.pipe';
import { TextBoldPipe } from '@pipes/text-bold.pipe';
import { VarianceArrowPipe } from '@pipes/variance-arrow.pipe';
import { CollaborationInputComponent } from '@shared/components/collaboration-input/collaboration-input.component';
import { LogoComponent } from '@shared/components/page-header/logo/logo.component';
import { PageHeaderComponent } from '@shared/components/page-header/page-header.component';
import { SpinnerComponent } from '@shared/components/spinner/spinner.component';
import { SvgIconComponent } from '@shared/components/svg-icon/svg-icon.component';
import { SvgSpinnerComponent } from '@shared/components/svg-spinner/svg-spinner.component';
import { DashboardService } from '@shared/services/dashboard.service';
import { KpiBoxService } from '@shared/services/kpi-box.service';
import { RefreshDashboardDataService } from '@shared/services/refresh-dashboard-data.service';
import { NgxEchartsModule } from 'ngx-echarts';
import { QuillModule } from 'ngx-quill';
import { ChipComponent } from './components/chip/chip.component';
import { BackgroundAnimationComponent } from './components/background-animation/background-animation.component';
import { BackgroundComponent } from './components/background/background.component';
import { CustomDropdownComponent } from './components/custom-dropdown/custom-dropdown.component';
import { FreeTextOutputComponent } from './components/free-text-output/free-text-output.component';
import { FreeTextPopupComponent } from './components/free-text-popup/free-text-popup.component';
import { ModalServiceModule } from './modal-service/modal-service.module';
import { RemoveCitationsPipe } from './pipes/remove-citations.pipe';
import { ApplicationSettingService } from './services/application-setting.service';
import { GlobalFilterService } from './services/global-filter.service';
import { PowerbiReportClickService } from './services/pbi-report-click.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BackgroundAnimationComponent,
    BackgroundComponent,
    GlobalSpinnerComponent,
    LogoComponent,
    PageHeaderComponent,
    SpinnerComponent,
    SvgIconComponent,
    SvgSpinnerComponent,
    ModalServiceModule.forRoot(),
    QuillModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
  ],
  declarations: [
    VarianceArrowPipe,
    LoadingPipe,
    CollaborationInputComponent,
    SettingsMenuComponent,
    FreeTextOutputComponent,
    FreeTextPopupComponent,
    ChipComponent,
    GroupMenuComponent,
    CustomDropdownComponent,
    NewLinePipe,
    TextBoldPipe,
    RemoveHyphenPipe,
    RemoveCitationsPipe,
  ],
  exports: [
    PageHeaderComponent,
    VarianceArrowPipe,
    CollaborationInputComponent,
    LoadingPipe,
    GlobalSpinnerComponent,
    SvgSpinnerComponent,
    SvgIconComponent,
    SpinnerComponent,
    SettingsMenuComponent,
    FreeTextOutputComponent,
    ChipComponent,
    BackgroundAnimationComponent,
    BackgroundComponent,
    GroupMenuComponent,
    CustomDropdownComponent,
    LogoComponent,
    NewLinePipe,
    TextBoldPipe,
    RemoveHyphenPipe,
    RemoveCitationsPipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  static injector: Injector;
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        ApplicationSettingService,
        KpiService,
        DataApiService,
        SubjectAreaService,
        BrandingService,
        FiltersService,
        FormUtilsService,
        DimensionService,
        OrUserSettingsService,
        ToastrService,
        KpiBoxService,
        RefreshDashboardDataService,
        GlobalFilterService,
        DashboardService,
        VisibilityAreaService,
        PowerbiReportClickService,
      ],
    };
  }
  constructor(injector: Injector) {
    SharedModule.injector = injector;
  }
}
